import(/* webpackMode: "eager" */ "/codebuild/output/src2173514757/src/medh-web/src/app/courses/page.tsx");
